import React, { useEffect, useState } from "react";
import { Input, Select, SelectItem, Button } from "@heroui/react";
// import { i } from "framer-motion/client";

export default function HeaderSection({
  // formatDateToDDMMYYYY,
  selectedMarketKey,
  setSelectedMarketKey,
  isOpenSuspend,
  isCloseSuspend,
  draw_date,
  markets,
  betTypes,
  betType,
  setBetType,
  setBetTime,
  setSelectedDigits,
  setStakeInput,
  setBetHistory,
  setRandomCount,
  DIGITS_MAP,
  RATE,
  rateMap,
  setDigitOptions,
  selectedRate,
  setSelectedRate,
  selectedType,
  setSelectedType,
  minMaxMap,
  setMinMaxMap,
  selectedMinMax,
  setSelectedMinMax,
  setDigitStakes,
  setSelectedStake,
  setLastSelectedDigit,
  betTime,
}) {
  useEffect(() => {
    setDigitOptions(DIGITS_MAP[betType]);
    setSelectedDigits([]);
  }, [betType, DIGITS_MAP, setDigitOptions, setSelectedDigits]);

  // const [selectedMarketKey, setSelectedMarketKey] = useState("open");
  // const [selectedMarketKey, setSelectedMarketKey] = useState("");
  let rawBetType = localStorage.getItem("betType");
  let betTypeIn =
    rawBetType === null || rawBetType === "null" ? "single" : rawBetType;
  const [selectedBetKey, setSelectedBetKey] = useState(betTypeIn);

  const bet_types = [
    { key: "single", label: "Single", icon: "/icons/single.svg" },
    {
      key: "singlePatti",
      label: "SinglePatti",
      icon: "/icons/single-patti.svg",
    },
    {
      key: "doublePatti",
      label: "Doublepatti",
      icon: "/icons/double-patti.svg",
    },
    {
      key: "tripplePatti",
      label: "Tripplepatti",
      icon: "/icons/triple patti.svg",
    },
    { key: "jodi", label: "Jodi", icon: "/icons/jodi.svg" },
  ];

  useEffect(() => {
    if (betTime === "open" && selectedBetKey === "jodi") {
      // Find the first bet type that is not "jodi"
      const firstAvailable = betTypes.find((item) => item.key !== "jodi");
      if (firstAvailable) {
        setSelectedBetKey(firstAvailable.key);
        setBetType(firstAvailable.key);
        setSelectedType(firstAvailable.key);
        setSelectedRate(rateMap[firstAvailable.key] || null);
        setSelectedMinMax(minMaxMap[firstAvailable.key] || {});
      }
    }
  }, [betTime]);

  return (
    <div className=" bg-white  w-full !p-0 !m-0">
      {" "}
      {/* remove all extra spacing */}
      <form className="w-full">
        <div className="md:grid grid-cols-1 md:grid-cols-4 md:p-3 gap-1 w-full px-4 md:px-1 mb-1 hidden">
          <Input
            label="DATE"
            value={draw_date}
            radius="none"
            isReadOnly
            labelPlacement="outside"
            className="w-full rounded-md border"
            classNames={{
              label: "text-md font-semibold ",
            }}
          />
          <div className="flex flex-col gap-1 w-full col-span-2">
            <label className="text-md font-semibold">MARKET</label>
            <div className="flex gap-2">
              <Button
                className={`w-full rounded-md border 
                ${
                  betTime === "open"
                    ? "border-m_border_blue text-black"
                    : "border-gray-300 bg-gray-200 text-black"
                }`}
                onClick={() => setBetTime("open")}
              >
                {markets[0]?.label}
              </Button>
              <Button
                className={`w-full rounded-md border 
                ${
                  betTime === "close"
                    ? "border-m_border_blue text-black"
                    : "border-gray-300 bg-gray-200 text-black"
                }`}
                onClick={() => setBetTime("close")}
              >
                {markets[1]?.label}
              </Button>
            </div>
          </div>
         
          <div className="flex flex-col w-full text-center hidden md:block">
            <label className="block text-md font-semibold mb-1.5">Rate</label>
            <div className="h-[30px] flex items-center justify-center px-3">
              <p className="font-semibold">{parseFloat(selectedRate)}</p>
            </div>
          </div>
          <div className="w-full" />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 w-full md:px-2 md:hidden">
          <div className="flex flex-col gap-1 w-full mb-1">
            <label className="text-xs font-semibold">MARKET</label>
            <Button
              className={`w-full rounded-md border 
              ${
                betTime === "open"
                  ? "border-m_border_blue text-black border-2"
                  : "border-gray-300 bg-gray-100 text-black"
              }`}
              onClick={() => setBetTime("open")}
            >
              {markets[0]?.label}
            </Button>
          </div>

          <div className="grid grid-cols-1 md:hidden gap-1  w-full">
            {/* BET TYPE */}
            <div className="flex flex-col gap-1 w-full">
              <div className="flex justify-end  ">
                <label className="text-xs font-bold italic text-end text-m_green">
                  Rate : {parseFloat(selectedRate)}
                </label>
              </div>

              <Button
                className={`w-full rounded-md border 
                ${
                  betTime === "close"
                    ? "border-m_border_blue text-black border-2"
                    : "border-gray-300 bg-gray-100 text-black"
                }`}
                onClick={() => setBetTime("close")}
              >
                {markets[1]?.label}
              </Button>
            </div>
          </div>
        </div>

        <div
          className={`grid gap-2 w-full mt-1 md:px-2`}
          style={{
            gridTemplateColumns: `repeat(${betTypes.length}, minmax(0, 1fr))`,
          }}
        >
          {betTypes.map((item) => {
            const isSelected = selectedBetKey === item.key;
            // Disable if already selected, or if it's the jodi button and marketType is "open"
            const isJodi = item.key === "jodi"; // or use item.label === "Jodi" if that's your label
            const isDisabled = (isJodi && betTime === "open");

            return (
              <button
                type="button"
                key={item.key}
                onClick={() => {
                  if (isDisabled) return;
                  setSelectedBetKey(item.key);
                  setBetType(item.key);
                  setSelectedType(item.key);
                  setSelectedRate(rateMap[item.key] || null);
                  setSelectedMinMax(minMaxMap[item.key] || {});
                  setDigitStakes({});
                  setSelectedStake("");
                  setLastSelectedDigit("");
                }}
                disabled={isDisabled}
                className={`flex-1 flex flex-col items-center gap-1 px-3 py-1 border rounded text-xs transition
          ${
            isSelected
              ? " border-m_border_blue border-2 text-m_black"
              : "bg-white text-black"
          }
          ${
            isDisabled
              ? "opacity-55"
              : " hover:text-black"
          }`}
              >
                <img src={item.icon} alt={item?.label} className="w-6 h-6" />
                {item?.label}
              </button>
            );
          })}
        </div>
      </form>
    </div>
  );
}
